import React from "react";
import ProAgentsImg from "@/img/cyt_agents.png";
import AccountCreationForm from "./account-creation-form";
import ActivitySelection from "./activity-selection";
import SelectPlan from "./select-plan";
import CircleSteps from "@/components/navigation/CircleSteps";
import useLocalStorage from "@/hooks/useLocalStorage";
import { Button } from "@/components/ui/button";
import { usePostHog } from "posthog-js/react";

export default function Index() {
  const [currentStep, setCurrentStep] = useLocalStorage("pro_signup_current_step", 0);
  const [selectedPlan, setSelectedPlan] = useLocalStorage("pro_signup_selected_plan", null);
  const posthog = usePostHog();
  const handoffApplied = React.useRef(false);

  React.useEffect(() => {
    if (handoffApplied.current) return;
    const urlParams = new URLSearchParams(window.location.search);
    const planFromUrl = urlParams.get("plan");
    const stepFromUrl = urlParams.get("step");

    if (planFromUrl) {
      handoffApplied.current = true;
      setCurrentStep(0);
      setSelectedPlan(planFromUrl);
      return;
    }

    if (stepFromUrl !== null) {
      const step = Number.parseInt(stepFromUrl, 10);
      if (Number.isInteger(step) && step >= 0 && step <= 2) {
        handoffApplied.current = true;
        setCurrentStep(step);
      }
    }
  }, [setCurrentStep, setSelectedPlan]);

  React.useEffect(() => {
    if (posthog) {
      posthog.capture("Signup - Pro", { step: 0, stepName: "started" });
    }
  }, [posthog]);

  const steps = [
    {
      id: "account",
      label: "Cuenta",
      component: <AccountCreationForm callBack={() => setCurrentStep(1)} />,
    },
    {
      id: "activity",
      label: "Actividad",
      component: <ActivitySelection callBack={() => setCurrentStep(2)} />,
    },
    {
      id: "plan",
      label: "Plan",
      component: <SelectPlan callBack={() => setCurrentStep(3)} selectedPlanId={selectedPlan} />,
    },
  ];
  return (
    <div className="min-h-screen max-w-screen-2xl m-auto items-center justify-center space-y-5">
      <div className="relative flex items-center justify-center mb-6 mt-12 max-w-screen-md mx-auto">
        {currentStep > 0 && (
          <Button
            variant="link"
            className="absolute left-0 text-lg cursor-pointer"
            onClick={() => {
              setCurrentStep(currentStep - 1);
            }}
          >
            &larr; Volver
          </Button>
        )}

        <img className="h-16 w-auto" src={ProAgentsImg} alt="Cyt Logo" />
      </div>

      <div className="text-2xl font-bold text-center">
        {
          {
            0: "Configura tu cuenta PRO en unos minutos",
            1: "Describe tu actividad",
            2: "Elige tu plan",
          }[currentStep]
        }
      </div>
      <div className="max-w-screen-md mx-auto space-y-5">
        <CircleSteps
          orientation="horizontal"
          steps={steps.map((step, index) => ({
            name: step.label,
            description: "",
            status:
              index < currentStep ? "complete" : index === currentStep ? "current" : "upcoming",
            id: step.id,
            href: "#",
          }))}
        />
      </div>
      {steps[currentStep].component}
    </div>
  );
}
